module.exports = __webpack_public_path__ + "assets/img/hospital-detail-head-back.d3185ad8.png";